import axios from '@/plugins/axios.js';
import InvalidPayload from '../exceptions/InvalidPayload.js';

export default {
    async start(leadId: number, callSid: string): Promise<void> {
        if (!leadId) {
            throw new InvalidPayload('Lead ID not provided.');
        }

        if (!callSid) {
            throw new InvalidPayload('Twilio call SID not provided.');
        }

        await axios.post(`v1/recordings/start-recording/${leadId}/${callSid}`);
    },

    async pause(leadId: number, callSid: string, recordingSid: string): Promise<void> {
        if (!leadId) {
            throw new InvalidPayload('Lead ID not provided.');
        }

        if (!callSid) {
            throw new InvalidPayload('Twilio call SID not provided.');
        }

        if (!recordingSid) {
            throw new InvalidPayload('Twilio recording SID not provided.');
        }

        await axios.post(`v1/recordings/pause-recording/${leadId}/${callSid}/${recordingSid}`);
    },

    async resume(leadId: number, callSid: string, recordingSid: string): Promise<void> {
        if (!leadId) {
            throw new InvalidPayload('Lead ID not provided.');
        }

        if (!callSid) {
            throw new InvalidPayload('Twilio call SID not provided.');
        }
        if (!recordingSid) {
            throw new InvalidPayload('Twilio recording SID not provided.');
        }

        await axios.post(`v1/recordings/resume-recording/${leadId}/${callSid}/${recordingSid}`);
    },
};
